(function () {
    'use strict';

    a3_cabin_reports.controller('JeppessenFlightDetailsCtrl', JeppessenFlightDetailsCtrl)

    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name JeppessenFlightDetailsCtrl
    * @description 
    *   Get the departure info times.
    * @ngInject
    */
    function JeppessenFlightDetailsCtrl($scope, $interval, LogService, refreshDelaySeconds, defaultCalendarDate, JeppesenFlightDetailsFactory, $routeParams, FlightFactory, $uibModal) {
        $scope.departureInfo = {};
        var flightId = $routeParams.flightId;
        var flight = FlightFactory.getFlightFromStorage(flightId);
        var autoUpdateInterval = null;
        var autoUpdateIntervalTimeOffset = null;
        var autoUpdateCounter = 0;
        $scope.STD = new Date(flight.ScheduledDeparture);
        $scope.isUpdatedTsat = false;
        $scope.isUpdatedTobt = false;
        $scope.isUpdatedCtot = false;
        $scope.isUpdatedETD = false;

        var raw = JeppesenFlightDetailsFactory.getJeppesenDetailsFromStorage(flightId) || {};
        var ctotRaw = JeppesenFlightDetailsFactory.getCtotHistoryFromStorage(flightId) || [];

        $scope.ctotHistoryRaw = ctotRaw;

        $scope.ctotHistory = ctotRaw.map(entry => ({
            value: new Date(entry.NewCTOT),
            previous: new Date(entry.OldCTOT),
            modified: new Date(entry.ModificationDate)
        }));

        $scope.departureInfo = raw.jeppesenData && raw.jeppesenData.length ? normalizeRawJeppesenArray(raw.jeppesenData) : {};

        /**
        * Returns the most recent CTOT value:
        * - From CTOT history if available
        * - Otherwise from flight.CTOT
        */
        $scope.getCurrentCTOT = function () {
            if ($scope.ctotHistoryRaw && $scope.ctotHistoryRaw.length) {
                var latest = $scope.ctotHistoryRaw.slice().sort((a, b) =>
                    new Date(b.ModificationDate) - new Date(a.ModificationDate)
                )[0];
                return new Date(latest.NewCTOT);
            }

            return flight.CTOT ? new Date(flight.CTOT) : null;
        };

        // $scope.departureInfo.ETD = $scope.departureInfo.ETD || new Date($scope.STD.getTime() + 10 * 60 * 1000); // Default ETD to STD + 10 minutes

        // Labels to show in UI
        $scope.timeLabels = ['STD', 'TOBT', 'TSAT', 'CTOT'];

        /**
        * Converts raw Jeppesen records into a structured object
        * with arrays per label and proper date formatting.
        */
        function normalizeRawJeppesenArray(rawArray) {
            var result = {
                TOBT: [],
                TSAT: [],
                CTOT: [],
                STD: null,
                ETD: null
            };

            rawArray.forEach(entry => {
                if (entry.STD) result.STD = new Date(entry.STD);
                if (entry.ETD) result.ETD = new Date(entry.ETD);

                ['TOBT', 'TSAT', 'CTOT'].forEach(key => {
                    if (entry[key]) {
                        result[key].push({
                            value: new Date(entry[key]),
                            lastUpdated: new Date(entry.Created || entry.CreatedDate || new Date())
                        });
                    }
                });
            });
            ['TOBT', 'TSAT', 'CTOT'].forEach(key => {
                result[key].sort((a, b) => new Date(b.created) - new Date(a.created));
            });
            return result;
        }

        /**
       * Delay check for TSAT > STD + 10 mins
       */
        $scope.isTsatDelayed = function () {
            if (!$scope.departureInfo.STD || !$scope.departureInfo.TSAT || !$scope.departureInfo.TSAT.length > 0)
                return false;

            const std = $scope.departureInfo.STD.getTime();
            const tsat = $scope.departureInfo.TSAT[$scope.departureInfo.TSAT.length - 1].value.getTime();
            const delayMinutes = 10 * 60 * 1000;

            return (tsat - std) >= delayMinutes;
        };

        /**
        * Delay check for TOBT > STD + 5 mins
        */
        $scope.isTobtDelayed = function () {
            if (!$scope.departureInfo.STD || !$scope.departureInfo.TOBT || !$scope.departureInfo.TOBT.length > 0)
                return false;

            const std = $scope.departureInfo.STD.getTime();
            const tobt = $scope.departureInfo.TOBT[$scope.departureInfo.TOBT.length - 1].value.getTime();
            const delayMinutes = 5 * 60 * 1000;

            return (tobt - std) >= delayMinutes;
        };

        /**
         * CTOT warning if CTOT > TOBT + 15 mins
         */
        $scope.isCtotWarning = function () {
            if (!$scope.departureInfo.CTOT || !$scope.departureInfo.CTOT.length > 0
                || !$scope.departureInfo.TOBT || !$scope.departureInfo.TOBT.length > 0)
                return false;

            const ctot = $scope.departureInfo.CTOT[$scope.departureInfo.CTOT.length - 1].value.getTime();
            const tobt = $scope.departureInfo.TOBT[$scope.departureInfo.TOBT.length - 1].value.getTime();
            const warningMinutes = 15 * 60 * 1000;

            return (ctot - tobt) >= warningMinutes;
        }

        /**
     * Opens generic history modal for TOBT, TSAT
     */
        $scope.openHistoryDialog = function (label) {
            const history = angular.copy($scope.departureInfo[label]);

            $uibModal.open({
                templateUrl: 'views/Dialogs/dlgJeppesenHistory.html',
                controller: function ($scope, $uibModalInstance) {
                    $scope.label = label;
                    $scope.history = history;

                    $scope.cancel = function () {
                        $uibModalInstance.dismiss();
                    };
                }
            });
        };

        /**
      * Opens CTOT-specific history modal
      */
        $scope.openCtotHistoryDialog = function () {
            $uibModal.open({
                templateUrl: 'views/Dialogs/dlgCTOTHistory.html',
                controller: function ($scope, $uibModalInstance, historyRaw) {
                    $scope.history = historyRaw.slice().sort((a, b) => new Date(b.ModificationDate) - new Date(a.ModificationDate)).map(entry => ({
                        value: new Date(entry.NewCTOT),
                        lastUpdated: new Date(entry.ModificationDate)
                    }));;

                    $scope.cancel = function () {
                        $uibModalInstance.dismiss();
                    };
                },
                resolve: {
                    historyRaw: function () {
                        return $scope.ctotHistoryRaw;
                    }
                }
            });
        };
        autoFetchDepartureDetailsInterval();


        /**
         * Fetches and updates Jeppesen flight details & CTOT history from api
         * and saves them back to local storage if available.
         */
        function autoFetchDepartureDetailsInterval() {
            autoUpdateCounter++;

            var estimatedDepartureTime = flight.ETD || flight.ScheduledDeparture;
            var actualDepartureTime = flight.ATD;
            var intervalTime = timerDelayGenerator(actualDepartureTime, estimatedDepartureTime, autoUpdateCounter);
            if ($scope.departureInfo && window.navigator.onLine && intervalTime > 0) {

                JeppesenFlightDetailsFactory.getDepartureDetails(flightId, flight.FlightNo, flight.DutyDate, flight.Departure)
                    .then(function (responseData) {

                        if (responseData == undefined || responseData.data == undefined || responseData.data.data == undefined) {
                            var err = new Error();
                            err.status = -1;
                            var msg = "ResponseData error in autoflightInfoInterval :" + JSON.stringify(responseData);
                            LogService.debug(msg, err);
                            return;
                        }

                        var raw = JeppesenFlightDetailsFactory.getJeppesenDetailsFromStorage(flightId) || {};
                        var ctotRaw = JeppesenFlightDetailsFactory.getCtotHistoryFromStorage(flightId) || [];

                        var oldCtot = $scope.getCurrentCTOT();
                        var oldtsat = $scope.departureInfo.TSAT && $scope.departureInfo.TSAT.length > 0 ? $scope.departureInfo.TSAT[0].value : null;
                        var oldtobt = $scope.departureInfo.TOBT && $scope.departureInfo.TOBT.length > 0 ? $scope.departureInfo.TOBT[0].value : null;
                        var oldETD = $scope.departureInfo.ETD ? $scope.departureInfo.ETD.toISOString() : null;

                        //Update scopes
                        $scope.ctotHistoryRaw = ctotRaw;
                        $scope.departureInfo = raw.jeppesenData && raw.jeppesenData.length ? normalizeRawJeppesenArray(raw.jeppesenData) : {};

                        //Get flight from storage
                        var flightForLS = FlightFactory.getFlightFromStorage(flightId);
                        $scope.departureInfo.ETD = flightForLS.ETD ? new Date(flightForLS.ETD) : null;
                        $scope.departureInfo.STD = flightForLS.ScheduledDeparture ? new Date(flightForLS.ScheduledDeparture) : null;
                        $scope.departureInfo.ATD = flightForLS.ATD ? new Date(flightForLS.ATD) : null;

                        //Check last values:
                        var newtsat = $scope.departureInfo.TSAT && $scope.departureInfo.TSAT.length > 0 ? $scope.departureInfo.TSAT[0].value : null;
                        var newtobt = $scope.departureInfo.TOBT && $scope.departureInfo.TOBT.length > 0 ? $scope.departureInfo.TOBT[0].value : null;
                        var newCtot = $scope.getCurrentCTOT();

                        $scope.isUpdatedTsat = normalizeTime(oldtsat) !== normalizeTime(newtsat);
                        $scope.isUpdatedTobt = normalizeTime(oldtobt) !== normalizeTime(newtobt);
                        $scope.isUpdatedCtot = normalizeTime(oldCtot) !== normalizeTime(newCtot);
                        $scope.isUpdatedETD = normalizeTime(oldETD) !== normalizeTime($scope.departureInfo.ETD);
                    }
                        // , function (err) {
                        //      LogService.debug("Error fetching departure details: " + err);
                        // })
                        ,function (err) {
                        var errorMessage = "Error fetching departure details";

                        if (err && typeof err === "object") {
                            try {
                                errorMessage += ": " + JSON.stringify(err);
                            } catch (e) {
                                errorMessage += ": [object with circular reference]";
                            }
                        } else {
                            errorMessage += ": " + err;
                        }

                        LogService.debug(errorMessage, err);
                    })
                    .finally(function () {
                        $scope.isFetchingDepartureData = false;
                    });


                if (intervalTime != autoUpdateIntervalTimeOffset) {
                    autoUpdateIntervalTimeOffset = intervalTime;
                    $interval.cancel(autoUpdateInterval);
                    autoUpdateInterval = $interval(autoFetchDepartureDetailsInterval, autoUpdateIntervalTimeOffset);
                }

            }
            else {
                $interval.cancel(autoUpdateInterval);
                $scope.showAutoUpdatePanel = false;
            }

        }

        function normalizeTime(t) {
            return t ? new Date(t).toISOString() : null;
        }

        function timerDelayGenerator(actualDepartureTime, estimatedDepartureTime, autoUpdateCounter) {
            var intervalTime = -1;
            var sec = 1000;
            var minutes = 60 * sec;
            var actualTimestamp = -1;
            var estimatedDepTimestamp = moment.utc(estimatedDepartureTime).valueOf();
            var nowTimeStamp = moment().valueOf();



            if (actualDepartureTime) {
                actualTimestamp = moment.utc(actualDepartureTime).valueOf();
            }
            else {
                if (actualDepartureTime) {
                    if (actualTimestamp > 0
                        && (actualTimestamp < nowTimeStamp || estimatedDepTimestamp - 120 * minutes < nowTimeStamp)) {
                        //Flight already departed or to earlier than 2 hours
                        intervalTime = -1;
                    } else {
                        intervalTime = refreshDelaySeconds * sec;
                    }
                } else if (estimatedDepTimestamp - 120 * minutes <= nowTimeStamp && estimatedDepTimestamp + 30 * minutes >= nowTimeStamp) {
                    intervalTime = refreshDelaySeconds * sec;
                }
            }

            //Test cases in development
            if (defaultCalendarDate) {
                debugger;
                nowTimeStamp = moment(defaultCalendarDate).valueOf();

                if (autoUpdateCounter < 2) {
                    return refreshDelaySeconds * sec;
                }
            }

            return intervalTime;
        }

    }
})();